
import ko from 'rgs-knockout';

require('./js/bindings');

import { BtnRadioGroupViewModel } from './js/model';
import template from './templates/template.html';


ko.components.register('btn-radio-group', {
	viewModel: BtnRadioGroupViewModel,
	template: template(),
});
